import script from "./web-exhibition-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./web-exhibition-detail.vue?vue&type=script&setup=true&lang=js"

import "./web-exhibition-detail.vue?vue&type=style&index=0&id=309b64ad&lang=scss"

const __exports__ = script;

export default __exports__